module.exports = __webpack_public_path__ + "static/media/flutter_logo.e8a54109.png";